<template>
  <input ref="tollfree-inputfield" v-model="inputText" class="inputfield" placeholder="EX: FLOWERS" maxlength="7" />
</template>

<script>
export default {
  name: 'TollfreeNumberInput',
  props: {
    value: [String, Number]
  },
  computed: {
    inputText: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val.toUpperCase());
        this.$emit('change', val.toUpperCase());
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.inputfield {
  position: relative;
  width: 260px;
  height: 60px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(223, 225, 229, 0.7);
  box-sizing: border-box;
  color: $colorTitle;
  outline: none !important;
  font-family: Inter;
  font-weight: bold;
  font-size: 29px;
  line-height: 35px;
  padding: 0 30px;
  letter-spacing: -0.04em;

  &::placeholder {
    color: #c2c7cf;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    width: 134px;
    height: 50px;
    font-weight: bold;
    font-size: 16px;
    line-height: 26px;
    padding: 0 12px;
  }
}
</style>
